import { OfficeError } from '../errors';
import { getReadItem } from './item';

const NOTIFICATION_ID = 'BB-Item-Notification';

/** Clears the currently displayed notification. */
export function clearNotification(): Promise<void> {
  return new Promise((resolve, reject) => {
    const item = getReadItem();
    item.notificationMessages.removeAsync(NOTIFICATION_ID, {}, (result) => {
      if (result.status === Office.AsyncResultStatus.Failed) {
        return reject(new OfficeError(result.error));
      }

      resolve();
    });
  });
}

/**
 * Adds or replaces the notification message with an error using the provided message.
 * @arg message The message to show the user. Will be prefixed with 'BombBomb: '.
 */
export function setErrorNotification(message: string): Promise<void> {
  return setNotification(message, Office.MailboxEnums.ItemNotificationMessageType.ErrorMessage);
}

/**
 * Adds or replaces the notification message with a progress indicator using the provided message.
 * @arg message The message to show the user. Will be prefixed with 'BombBomb: '.
 */
export function setProgressNotification(message: string): Promise<void> {
  return setNotification(message, Office.MailboxEnums.ItemNotificationMessageType.ProgressIndicator);
}

/**
 * Adds or replaces the notification message with the current message and type.
 * @arg message The message to show the user. Will prefix with 'BombBomb: '.
 * @arg type The type of message to show.
 */
function setNotification(
  message: string,
  type: Office.MailboxEnums.ItemNotificationMessageType,
): Promise<void> {
  return new Promise((resolve, reject) => {
    const item = getReadItem();
    item.notificationMessages.replaceAsync(
      NOTIFICATION_ID,
      {
        message: `BombBomb: ${message}`,
        type,
      },
      {},
      (result) => {
        if (result.status === Office.AsyncResultStatus.Failed) {
          return reject(new OfficeError(result.error));
        }

        resolve();
      },
    );
  });
}
